/**
* Copyright Zendesk, Inc.
*
* Use of this source code is governed under the Apache License, Version 2.0
* found at http://www.apache.org/licenses/LICENSE-2.0.
*/
import styled, { css } from 'styled-components';
import { getLineHeight, getColorV8, retrieveComponentStyles, DEFAULT_THEME } from '@zendeskgarden/react-theming';

const COMPONENT_ID = 'breadcrumbs.item';
const linkStyles = _ref => {
  let {
    isCurrent
  } = _ref;
  return css(["& > :link,& > :visited{white-space:inherit;}", ""], isCurrent && `
      & > :link,
      & > :visited,
      & > :link:hover,
      & > :visited:hover,
      & > :link:focus,
      & > :visited:focus {
        color: inherit;
      }
    `);
};
const StyledBreadcrumbItem = styled.li.attrs({
  'data-garden-id': COMPONENT_ID,
  'data-garden-version': '8.76.9'
}).withConfig({
  displayName: "StyledBreadcrumbItem",
  componentId: "sc-r0suq7-0"
})(["line-height:", ";white-space:nowrap;color:", ";font-size:inherit;", ";", ";"], props => getLineHeight(props.theme.space.base * 5, props.theme.fontSizes.md), props => props.isCurrent ? getColorV8(props.theme.colors.neutralHue, 600) : 'inherit', linkStyles, props => retrieveComponentStyles(COMPONENT_ID, props));
StyledBreadcrumbItem.defaultProps = {
  theme: DEFAULT_THEME
};

export { StyledBreadcrumbItem };
